import upsell from "../upsell"
import primer from "../primer"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("premium"),
  ...primer(),

  onInit() {
    this.initUpsell()
    this.initPrimer({
      checkoutCompletePath: this.getThankYouPath(),
    })
  },
})
